<div *ngIf="loading$|async" class="k-loading-panel">
    <div class="k-loading-panel-mask"></div>
    <div class="k-loading-panel-wrapper">      
        <div class="loader" style="text-align: center;">
            <i class="lin-loading-circle"></i>
            <p>{{ 'Loading' | transloco }}</p>       
        </div> 
      </div>
</div>


